import type { EventCheckoutData } from "@/types";

const DEFAULT_LANGUAGE = 'da';

type LocalizationKeys = keyof EventCheckoutData['localizations'][string];

export const getLocalizedEventValue = (
  event: EventCheckoutData,
  language: string = DEFAULT_LANGUAGE,
  key: LocalizationKeys,
  characterLimit: number = 0
): string => {
  let value = event.localizations?.[language]?.[key] || Object.values(event.localizations || {}).find(localization => localization[key])?.[key] || '';
  if( characterLimit > 0  && value.length > characterLimit ) {
    value = value.slice(0, characterLimit) + '...';
  }
  return value;
};

// Helper function to get the eventtime with GMT offset applied. This time "format" is referred to as safetickettime in the codebase.
export const getEventtime = (event: EventCheckoutData): number => { return event.eventtime + event.eventtime_gmt_offset; };